<template>
  <CardedDisplay>
    <PlainDisplay icon="mdi-info" :title="business.description">
      <br/>
      <v-row class="ma-0 pa-0">
        <v-col class="">
          <div class="d-flex justify-space-between">
            <b>Our Products List</b>
            <v-btn
              :disabled="is_loading"
              :to="
                '/owner/businesses/list/view/' +
                $route.params.id +
                '/products/manage'
              "
              small
              rounded
              class="mr-4"
              outlined
              color="success"
              v-if="is_owner && is_in_admin_view == false && is_in_public_view == false"
            >
              <v-icon left>mdi-plus</v-icon> Manage Products
            </v-btn>
          </div>
          <ul class="items-list">
            <li v-for="(product, index) in business.products" :key="index">
              {{ product.name }}
            </li>
          </ul>
          <div
            class="text-center"
            v-if="business.products.length == 0 && (!is_owner || is_in_admin_view == true || is_in_public_view == true)"
          >
            <v-icon>mdi-sad-emogi</v-icon>
            <p>
              <b>!Oops,</b> Business has not yet <br />
              registered any products <br />
            </p>
          </div>
          <div
            class="text-center"
            v-if="business.products.length == 0 && is_owner && is_in_admin_view == false && is_in_public_view == false"
          >
            <v-icon>mdi-sad-emogi</v-icon>
            <p>
              <b>!Oops,</b> You have not yet added any products, <br />
              please click the
              <v-btn
                :to="
                  '/owner/businesses/list/view/' +
                  $route.params.id +
                  '/products/manage'
                "
                text
                small
                :disabled="is_loading"
              >
                <b>Manage Products</b> </v-btn
              >, <br />
              button above to add products
            </p>
          </div>
        </v-col>
        <v-col class="">
          <div class="d-flex justify-space-between">
            <b>Our Services List</b>
            <v-btn
              :to="
                '/owner/businesses/list/view/' +
                $route.params.id +
                '/services/manage'
              "
              :disabled="is_loading"
              small
              rounded
              class="mr-4"
              outlined
              color="success"
              v-if="is_owner && is_in_admin_view == false && is_in_public_view == false"
            >
              <v-icon left>mdi-plus</v-icon> Manage Services
            </v-btn>
          </div>
          <ul class="items-list">
            <li v-for="(service, index) in business.services" :key="index">
              {{ service.name }}
            </li>
          </ul>
          <div
            class="text-center"
            v-if="business.services.length == 0 && (!is_owner || is_in_admin_view == true || is_in_public_view == true )"
          >
            <v-icon>mdi-sad-emogi</v-icon>
            <p>
              <b>!Oops,</b> Business has not yet <br />
              registered any services <br />
            </p>
          </div>
          <div
            class="text-center"
            v-if="business.services.length == 0 && is_owner && is_in_admin_view == false  && is_in_public_view == false "
          >
            <v-icon>mdi-sad-emogi</v-icon>
            <p>
              <b>!Oops,</b> You have not yet added any services, <br />
              please click the
              <v-btn
                :to="
                  '/owner/businesses/list/view/' +
                  $route.params.id +
                  '/services/manage'
                "
                text
                small
                :disabled="is_loading"
              >
                <b>Manage Services</b> </v-btn
              >, <br />
              button above to add services
            </p>
          </div>
        </v-col>
      </v-row>
      <br/>
      This business belongs to the following categories
      <v-row
        no-gutters
        v-for="(belonging, index) in business.belongings"
        :key="index"
        class="grey-border"
      >
        <v-col
          no-gutters
          class="mr-0 pointer"
          @click="go_to_category(belonging.category.id)"
        >
          <div class="d-flex justify-space-between align-center">
            <v-img
              :src="belonging.category.thumb_nail"
              alt="Category"
              class="grey lighten-5"
              :max-height="categ_thumb_size"
              :height="categ_thumb_size"
              :width="categ_thumb_size"
              :max-width="categ_thumb_size"
            >
            </v-img>
            <div class="flex-grow-1 text-center grey lighten-5 pa-2">
              <div class="text-left mb-4 d-flex justify-space-between">
                <span>Category:</span>
                <span v-if="parseInt(belonging.category.is_top_category) == 1">
                  <b>Top Category</b>
                </span>
              </div>
              <span
                ><v-icon large>{{ belonging.category.icon }}</v-icon></span
              >
              <div class="mb-4 mt-4 text-h6">
                <strong>{{ belonging.category.name }}</strong>
              </div>
            </div>
          </div>
        </v-col>
        <v-col
          no-gutters
          class="ml-0 pointer"
          @click="
            go_to_sub_category(belonging.category.id, belonging.sub_category.id)
          "
        >
          <div class="d-flex justify-space-between  align-center">
            
            <v-img
              :src="belonging.sub_category.thumb_nail"
              alt="Sub Category"
              class="grey darken-4"
              :max-height="categ_thumb_size"
              :height="categ_thumb_size"
              :width="categ_thumb_size"
              :max-width="categ_thumb_size"
            >
            </v-img>
            <div class="flex-grow-1 text-center grey lighten-5 pa-2">
              <div class="text-left mb-4 d-flex justify-space-between">
                <span>Sub Category:</span>
                <span v-if="parseInt(belonging.category.is_top_category) == 1">
                  <b>&nbsp;</b>
                </span>
              </div>
              <span
                ><v-icon large>{{ belonging.sub_category.icon }}</v-icon></span
              >
              <div class="mb-4 mt-4 text-h6">
                <strong>{{ belonging.sub_category.name }}</strong>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <br />
      
    </PlainDisplay>
  </CardedDisplay>
</template>


<script>
import CardedDisplay from "./../components/CardedDisplay";
import PlainDisplay from "./../components/PlainDisplay";
import Utils from "./../lib/Utils";
export default {
  name: "BusinessViewDescription",
  components: {
    CardedDisplay,
    PlainDisplay,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner: {
      type: Boolean,
      default: false,
    },
    business: {
      type: Object,
      default: function () {
        return Utils.get_default_business();
      },
    },
    is_in_admin_view: {
      type: Boolean,
      default: false,
    },
    is_in_public_view: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      categ_thumb_size: 150,
    };
  },
  methods: {
    go_to_category(category_id) {
      if(this.is_in_admin_view == true){
        this.$router.push("/admin/categories/view/" + category_id);
      }else{
       this.$router.push("/categories/" + category_id);
      }
    },
    go_to_sub_category(category_id, sub_category_id) {
      if(this.is_in_admin_view == true){
        this.$router.push("/admin/categories/sub_categories/view/" + sub_category_id);
      }else{
        this.$router.push(
          "/categories/" + category_id + "/sub_category/" + sub_category_id
        );
      }
    },
  }
};
</script>

<style scoped>
.items-list {
  margin-top: 10px;
}
.items-list li {
  padding: 2px;
  padding-left: 5px;
}
.items-list li:nth-child(even) {
  background-color: #cccccc47;
}

.grey-border{
  border: 2px solid #e0e0e0 !important;
}
</style>